export const getFeaturedCampaigns = ({ Rocket, Code, Mic, Target }) => [
  {
    id: 'investor-magnet',
    title: 'Investor Magnet',
    tagline: 'High-Conversion Landingpage inklusive Strategie-Audit, Design & Deployment.',
    price: 'ab €2.799',
    slots: 2,
    total: 5,
    color: '#2563eb',
    icon: Rocket,
  },
  {
    id: 'ai-voice-agent',
    title: 'AI Voice Agent',
    tagline: 'Automatisierte Telefonie & Support mit intelligenten Voice-Agenten rund um die Uhr.',
    price: 'ab €3.499',
    slots: 1,
    total: 4,
    color: '#ec4899',
    icon: Mic,
  },
  {
    id: 'vibe-coding',
    title: 'Rapid Prototyping',
    tagline: 'AI-native MVP Entwicklung fuer schnelle Prototypen, Tests und Investor-Demos.',
    price: 'ab €4.999',
    slots: 1,
    total: 3,
    color: '#a855f7',
    icon: Code,
  },
];